import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=f3545afa&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=f3545afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3545afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3545afa')) {
      api.createRecord('f3545afa', component.options)
    } else {
      api.reload('f3545afa', component.options)
    }
    module.hot.accept("./withdraw.vue?vue&type=template&id=f3545afa&scoped=true&", function () {
      api.rerender('f3545afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/withdraw.vue"
export default component.exports